import React from 'react';

import { Box, Button, IconButton, Typography } from '@mui/material';
import { CancelIcon, ConfirmIcon } from '@sharedCR/coreDesignSystem/icons';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import {
  actionButtonSx,
  closeButtonSx,
  leadIconSx,
  selectedCountSx,
  selectionBarSx,
} from './SelectionActionBar.styles';
import { SelectionActionBarTestIds } from './SelectionActionBar.testIds';

const SelectionActionBar = ({
  selectedCount,
  isCopyDocumentsAllowed = false,
  isLoading = false,
  onMergePdf = _.noop,
  onCopyDocuments = _.noop,
  onClearSelection = _.noop,
}) => (
  <Box sx={selectionBarSx}>
    <Box sx={leadIconSx}>
      <ConfirmIcon size={IconSize[20]} />
    </Box>
    <Typography sx={selectedCountSx} variant="medium12">
      {`${selectedCount} selected`}
    </Typography>
    <Button
      data-testid={SelectionActionBarTestIds.MERGE_BUTTON}
      disabled={isLoading}
      sx={actionButtonSx}
      variant="text"
      onClick={onMergePdf}
    >
      Merge
    </Button>
    {isCopyDocumentsAllowed && (
      <Button
        data-testid={SelectionActionBarTestIds.COPY_BUTTON}
        disabled={isLoading}
        sx={actionButtonSx}
        variant="text"
        onClick={onCopyDocuments}
      >
        Copy to loan
      </Button>
    )}
    <IconButton
      aria-label="Clear selection"
      data-testid={SelectionActionBarTestIds.CLEAR_BUTTON}
      sx={closeButtonSx}
      onClick={onClearSelection}
    >
      <CancelIcon size={IconSize[20]} />
    </IconButton>
  </Box>
);

SelectionActionBar.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  isCopyDocumentsAllowed: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClearSelection: PropTypes.func,
  onCopyDocuments: PropTypes.func,
  onMergePdf: PropTypes.func,
};

export default SelectionActionBar;
